module.exports = __webpack_public_path__ + "img/8_military.17d3ca6e.png";